<script>

export default {
    data() {
        return {
            show: false,
            data: null,
            startHeight: 0
        }
    },
    mounted() {
        this.$nextTick().then(() => {
            this.startHeight = this.$refs.readmorewrap.offsetHeight;
            this.$refs.readmorewrap.style.maxHeight = `${this.startHeight}px`;
        });
    },
    methods: {
        makeShow() {
            this.show = true;
            this.$refs.readmorewrap.style.maxHeight = `10000px`;
            this.$refs.readmorewrap.style.transition = `all 3s ease-in-out`;
            
            setTimeout(() => {
                this.$refs.readmorewrap.style.maxHeight = null;
            }, 500);
        },
        makeHide() {
            this.$refs.readmorewrap.style.maxHeight = `${this.$refs.readmorewrap.offsetHeight}px`;
            this.$refs.readmorewrap.style.transition = `all 0.5s ease-in-out`;

            setTimeout(() => {
                this.$refs.readmorewrap.style.maxHeight = `${this.startHeight}px`;
            }, 1);
            
            setTimeout(() => {
                this.show = false;
            }, 500);  
        }
    }
}
</script>
